export default __webpack_public_path__ + "static/media/login-img.1fbcf21b.png";